import axios from 'axios'

const api = axios.create({
    baseURL: 'https://inove.quixada.ufc.br/api'
    //baseURL: 'http://localhost:3000'
})

export default api